<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-row>
            <el-form-item label="退款单号" class="fn-left">
              <el-input v-model="listQuery.refund_id" />
            </el-form-item>
            <el-form-item label="学员ID" class="fn-left">
              <el-input v-model="listQuery.sub_id" />
            </el-form-item>
            <el-form-item label="学员姓名" class="fn-left">
              <el-input v-model="listQuery.sub_name" />
            </el-form-item>

          </el-row>
          <el-row>
            <el-form-item label="选择时间" class="fn-left">
              <Select key="5" :selected.sync="listQuery.time_type" :data="timeTypeLists" clearable placeholder="请选择" />
              <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
            </el-form-item>
            <el-form-item label="订单状态" class="fn-left">
              <Select key="5" :selected.sync="listQuery.status" :data="refundStatus" clearable placeholder="请选择" />
            </el-form-item>
          </el-row>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetOrderSignLists">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="创建时间" prop="create_time" align="center" />
        <el-table-column label="最后操作时间" prop="modify_time" align="center" />
        <el-table-column label="退款单号" prop="refund_id" align="center" />
        <el-table-column label="学员ID" prop="sub_id" align="center" />
        <el-table-column label="学员姓名" prop="sub_name" align="center" />
        <el-table-column label="退款金额" align="center">
          <template slot-scope="{row}">
            {{ row.amount/100 }}元
          </template>
        </el-table-column>
        <el-table-column label="责任人" prop="responsible_name" align="center" />
        <el-table-column label="订单状态" prop="status_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnPopDetail(row)">订单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetOrderSignLists" />
    </div>
    <el-dialog v-if="bShowDetail" title="退款详情" :visible.sync="bShowDetail">
      <refund-detail :refund="currentRefund" :edit="false" />
    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import RefundDetail from './components/RefundDetail'
// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TyyKnowledgeSettingLists',
  components: {
    Select,
    RefundDetail
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        refund_id: '',
        begin_date: '',
        end_date: '',
        total: 0,
        time: '',
        sub_id: '',
        sub_name: '',
        time_type: '',
        status: ''
      },
      bShowDetail: false,
      timeTypeLists: commondata.TYY_TIME_TYPE,
      currentRefund: '',
      refundStatus: [
        { id: '100', name: '待学习管家审批' },
        { id: '105', name: '待总部审批' },
        { id: '102', name: '待财务审批' },
        { id: '2', name: '审核成功' },
        { id: '3', name: '审核失败' }
      ]
    }
  },
  created() {
    this.fnGetOrderSignLists()
  },
  methods: {
    fnGetOrderSignLists: function() {
      this.bShowDetail = false
      this.$http.tyyGetRefundList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_date = val[0]
        this.listQuery.end_date = val[1]
      } else {
        this.listQuery.begin_date = ''
        this.listQuery.end_date = ''
        this.listQuery.time = []
      }
    },
    fnPopDetail: function(refund) {
      this.currentRefund = refund.refund_id
      this.bShowDetail = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
